import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import naacLogo from "../assets/img/rec/naac.webp";

export default function AccreditationNaac() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* HERO */}
                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute left-0 top-[100px] h-px w-full bg-white/[0.06]" />
                        <div className="absolute right-0 top-0 h-full w-[40%] bg-[#0C2744]" />
                        <div className="absolute right-0 top-0 h-full w-[40%] opacity-[0.04] [background-image:linear-gradient(rgba(255,255,255,.7)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.7)_1px,transparent_1px)] [background-size:48px_48px]" />
                        <div className="absolute bottom-0 left-0 h-[5px] w-[30%] bg-[#8B1E3F]" />
                        <div className="absolute bottom-0 left-[30%] h-[5px] w-[15%] bg-[#D5AD57]" />
                    </div>


                    <div className="relative mx-auto grid min-h-[620px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.08fr_.92fr]">

                        {/* LEFT */}
                        <div className="flex flex-col justify-center py-16 pr-8 lg:py-20 lg:pr-20">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                <span className="h-px w-12 bg-current" />
                                NAAC Accreditation
                            </div>

                            <h1 className="mt-7 max-w-[840px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6.1vw,90px)] font-normal leading-[0.95] tracking-[-0.045em]">
                                Quality reviewed.
                                <span className="block text-[#D5AD57]">
                                    Standards strengthened.
                                </span>
                            </h1>

                            <p className="mt-8 max-w-[700px] text-[17px] leading-8 text-white/65">
                                NAAC accreditation reflects a structured institutional approach towards quality assurance, academic performance and continuous improvement.
                            </p>


                            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-white/15 pt-7">

                                {[
                                    "Assessment",
                                    "Quality Assurance",
                                    "Academic Standards",
                                    "Continuous Review",
                                ].map((item) => (
                                    <div key={item} className="flex items-center gap-3">
                                        <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]" />
                                        <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/60">{item}</span>
                                    </div>
                                ))}

                            </div>

                        </div>


                        {/* RIGHT - QUALITY DOSSIER */}
                        <div className="relative hidden lg:flex lg:items-center lg:justify-center">

                            <div className="relative w-[390px]">

                                <span className="absolute -right-12 -top-14 font-['Libre_Caslon_Display',Georgia,serif] text-[180px] leading-none text-white/[0.025]">
                                    Q
                                </span>


                                <div className="relative bg-[#F7F2E8] p-7 text-[#071A2F] shadow-[0_30px_90px_rgba(0,0,0,.25)]">

                                    <div className="border border-[#071A2F]/10">

                                        <div className="flex items-center justify-between border-b border-[#071A2F]/10 p-5">

                                            <span className="text-[8px] font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                                                Institutional Quality
                                            </span>

                                            <span className="text-[8px] font-bold uppercase tracking-[0.14em] text-[#071A2F]/35">
                                                NAAC
                                            </span>

                                        </div>


                                        <div className="flex min-h-[160px] items-center justify-center bg-white p-5">

                                            <img src={naacLogo} alt="NAAC" className="max-h-[120px] max-w-[210px] object-contain" />

                                        </div>


                                        <div className="grid grid-cols-2 border-t border-[#071A2F]/10">

                                            {[
                                                ["01", "Review"],
                                                ["02", "Benchmark"],
                                                ["03", "Assess"],
                                                ["04", "Improve"],
                                            ].map(([number, label], index) => (
                                                <div key={number} className={`p-5 ${index % 2 === 0 ? "border-r" : ""} ${index < 2 ? "border-b" : ""} border-[#071A2F]/10`}>

                                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#D5AD57]">
                                                        {number}
                                                    </span>

                                                    <p className="mt-3 text-[9px] font-bold uppercase tracking-[0.13em] text-[#071A2F]">
                                                        {label}
                                                    </p>

                                                </div>
                                            ))}

                                        </div>

                                    </div>

                                </div>


                                <div className="ml-[-25px] mt-[-22px] w-[220px] bg-[#8B1E3F] p-5 text-white shadow-xl">

                                    <span className="text-[8px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        Quality Culture
                                    </span>

                                    <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[20px] leading-[1.2]">
                                        Review. Reflect. Improve.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* INTRODUCTION */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.68fr_1.32fr] lg:gap-20">

                        <div>
                            <Eyebrow>NAAC Accreditation</Eyebrow>

                            <Title before="A Commitment to" highlight="Institutional Quality" after="" position="middle" theme="burgundy" />
                        </div>


                        <div className="lg:pt-7">

                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(27px,3vw,41px)] font-normal leading-[1.35] text-[#071A2F]">
                                Quality assurance is not a single exercise. It is a continuous institutional process of assessment, reflection and improvement.
                            </p>

                            <p className="mt-7 max-w-[850px] text-[15px] leading-8 text-[#65727E]">
                                NAAC accreditation encourages institutions to strengthen academic systems, governance practices, student support, research culture and internal quality mechanisms.
                            </p>

                        </div>

                    </div>

                </section>


                {/* QUALITY CYCLE */}
                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[.72fr_1.28fr] lg:gap-20">

                            <div>

                                <Eyebrow>Quality Cycle</Eyebrow>

                                <Title before="From Assessment to" highlight="Continuous Improvement" after="" position="middle" theme="burgundy" />

                                <p className="mt-7 max-w-[460px] text-[15px] leading-8 text-[#65727E]">
                                    Institutional quality strengthens when review and improvement become part of regular academic and administrative practice.
                                </p>

                            </div>


                            <div className="relative">

                                <div className="absolute left-[28px] top-0 hidden h-full w-px bg-[#D5AD57]/40 sm:block" />


                                {[
                                    ["01", "Assess", "Review institutional performance and academic practices."],
                                    ["02", "Benchmark", "Compare processes and outcomes against established quality expectations."],
                                    ["03", "Reflect", "Identify strengths, gaps and opportunities for development."],
                                    ["04", "Improve", "Translate review findings into institutional enhancement."],
                                ].map(([number, title, text]) => (
                                    <div key={number} className="relative grid gap-5 border-b border-[#071A2F]/10 py-7 sm:grid-cols-[58px_190px_1fr] sm:items-start">

                                        <span className="relative z-10 grid h-[58px] w-[58px] place-items-center rounded-full border border-[#D5AD57] bg-[#F7F2E8] font-['Libre_Caslon_Display',Georgia,serif] text-[19px] text-[#8B1E3F]">
                                            {number}
                                        </span>

                                        <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[25px] text-[#071A2F]">
                                            {title}
                                        </h3>

                                        <p className="text-[14px] leading-7 text-[#65727E]">
                                            {text}
                                        </p>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </section>


                {/* QUALITY AREAS */}
                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_420px] lg:items-end">

                            <div>
                                <Eyebrow>Institutional Quality</Eyebrow>
                                <Title before="Strengthening" highlight="Core Academic Systems" after="" position="middle" theme="burgundy" />
                            </div>

                            <p className="text-[15px] leading-8 text-[#65727E]">
                                A quality-focused institution considers academic, administrative and student-development processes together.
                            </p>

                        </div>


                        <div className="mt-14 grid gap-px bg-[#071A2F]/10 md:grid-cols-2 lg:grid-cols-3">

                            {[
                                ["01", "Teaching & Learning", "Academic delivery, learner engagement and teaching effectiveness."],
                                ["02", "Research & Innovation", "Research culture, academic inquiry and knowledge development."],
                                ["03", "Student Support", "Support services, participation and student development."],
                                ["04", "Governance", "Leadership, institutional planning and responsible administration."],
                                ["05", "Infrastructure", "Facilities and resources supporting academic delivery."],
                                ["06", "Quality Assurance", "Internal review, documentation and continuous enhancement."],
                            ].map(([number, title, text], index) => (
                                <article key={number} className={`min-h-[265px] p-8 ${index === 0 || index === 5 ? "bg-[#071A2F] text-white" : index === 2 ? "bg-[#EEF4F8]" : "bg-[#F7F2E8]"}`}>

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[31px] text-[#D5AD57]">
                                        {number}
                                    </span>

                                    <h3 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[26px] leading-[1.15]">
                                        {title}
                                    </h3>

                                    <p className={`mt-4 text-[14px] leading-7 ${index === 0 || index === 5 ? "text-white/55" : "text-[#65727E]"}`}>
                                        {text}
                                    </p>

                                </article>
                            ))}

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}